import React, { useState, useRef } from 'react';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import image from "assets/img/bg7.jpg";
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'

const useStyles = makeStyles(styles);

export default function LoginPage(props) {
  const { ...rest } = props;
  const inputPhoneNumber = useRef(null)
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  setTimeout(function () {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();
  var onEnterPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      SendCode();
    }
  }
  var SendCode = () => {
    var phoneNumber = inputPhoneNumber.current.value
    Axios.post(Config.api + "Authentication/SendCode", {
      phoneNumber: phoneNumber
    },
      {
        headers: {
          apikey: Config.apikey
        }
      }).then((result) => {
        props.history.push("VerifyCode/" + phoneNumber);
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status == 422)
          swal("شماره موبایل نادرست است.");
        else if (err && err.response && err.response.data && err.response.data.fa_message) {
          swal(err.response.data.fa_message);
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }

  return (
    <div>
      <Header
        absolute
        color="transparent"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center"
        }}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h5>ورود با رمز پویا</h5>
                  </CardHeader>
                  <CardBody>
                    <CustomInput
                      labelText="شماره موبایل..."
                      id="MobileNumber"
                      onKeyPress={onEnterPress}
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "tel",
                        inputRef: inputPhoneNumber,
                        endAdornment: (
                          <InputAdornment position="end">
                            <PhoneAndroidIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                    />
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <div className={classes.extra}>
                      <a className={classes.extraLink} href='SignIn'>
                        ورود با رمز عبور ایستا
                      </a>
                    </div>
                    <Button onClick={SendCode} color="success">
                      <ArrowBackIosIcon />
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
